import { render, staticRenderFns } from "./OfferRequests.vue?vue&type=template&id=cfa31f12&scoped=true"
import script from "./OfferRequests.vue?vue&type=script&lang=ts"
export * from "./OfferRequests.vue?vue&type=script&lang=ts"
import style0 from "./OfferRequests.vue?vue&type=style&index=0&id=cfa31f12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa31f12",
  null
  
)

export default component.exports